import MapWrapper from '../../map-wrapper';
import LocationFilters from '../../location-filters';
import './style.scss';
import StoreList from './store-list';
import GenericaLocationFilters from './location-filters';
import FeatureFilters from './feature-filters';
import StoreCards from '../../store-cards';

export default function Generica() {
    return (
        <section className="shops section-indent container generica-wtb">
            <h1 className="shops__title title title--h1">Где купить</h1>
            <LocationFilters render={GenericaLocationFilters} />
            <div className="shops__tabs tabs">
                <FeatureFilters />
                <div className="tabs__desc-wrapper tabs__desc-wrapper--shops">
                    <StoreCards render={StoreList} />
                    <MapWrapper className="shops__map" width="100%" height="100%" />
                </div>
            </div>
        </section>
    );
}
